import { extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import Form from 'react-bootstrap/Form';
import { SelectionControl } from '../../../../core/components/SelectionControl/component.js';
var Checkbox = function Checkbox(props) {
  var checkClassName = props.checkClassName,
    chakra = props.chakra,
    children = props.children,
    isDisabled = props.isDisabled,
    name = props.name,
    inputRef = props.inputRef,
    id = props.id,
    key = props.key,
    onChange = props.onChange,
    onClick = props.onClick,
    labelAction = props.labelAction,
    labelClassName = props.labelClassName,
    isChecked = props.isChecked,
    inputClassName = props.inputClassName,
    type = props.type,
    value = props.value;
  var render = function render() {
    // data-* attributes get applied via props, or inputProps for chakra
    if (chakra && chakra === 'off') {
      return /*#__PURE__*/React.createElement(Form.Check, {
        className: checkClassName,
        key: key
      }, /*#__PURE__*/React.createElement(Form.Check.Label, {
        className: labelClassName,
        "data-action": labelAction,
        htmlFor: id
      }, /*#__PURE__*/React.createElement(Form.Check.Input, _extends({}, props, {
        checked: isChecked,
        className: inputClassName,
        disabled: isDisabled,
        id: id,
        ref: inputRef,
        name: name,
        onChange: onChange,
        onClick: onClick,
        type: type,
        value: value
      })), /*#__PURE__*/React.createElement("i", {
        className: "input-helper"
      }), children));
    } else {
      return /*#__PURE__*/React.createElement(SelectionControl, props);
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, render());
};
Checkbox.displayName = 'Checkbox';
export { Checkbox };